// GA4 event tracking helper.
// Safe no-op if gtag hasn't loaded (ad blockers, offline, dev).
export function track(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // never let analytics break the app
  }
}
